import React from "react";
import { Modal, Container } from "semantic-ui-react";
import GLGIcon from "./GLGIcon";
import { Trans, useTranslation } from "react-i18next";

const pStyle = { padding: "1rem" };
export default function ModalError() {
  const [t] = useTranslation()

  return (
    <Modal
      defaultOpen
      closeOnEscape={false}
      closeOnDimmerClick={false}
      size="tiny"
    >
      <Modal.Content>
        <Container textAlign="center" fluid>
          <GLGIcon name="alert-2" size="huge" />
          <p style={pStyle}>
            {t("error_has_occured")}
            <br/>
            <br/>
            <Trans i18nKey="try_again_later">
              <a
                href="https://glginsights.com/council-members/contact/"
                target="_blank"
                rel="noopener noreferrer"
              >
              contact copy, DONT TRANSLATE, JUST NEED COPY HERE FOR I18NEXT
              </a>
            </Trans>
          </p>
        </Container>
      </Modal.Content>
    </Modal>
  );
}
